document.addEventListener('click', function (e) { 
  var link = e.target.closest('[data-dl-item-id]'); 
  if (!link) return; 
  var d = link.dataset; 
  window.dataLayer = window.dataLayer || []; 
  window.dataLayer.push({ ecommerce: null }); 
  window.dataLayer.push({ 
    'event': 'select_item', 
    'ecommerce': { 
      'item_list_id': d.dlListId || '', 
      'item_list_name': d.dlListName || '', 
      'currency': window.Shopify ? Shopify.currency.active : 'RON', 
      'items': [{ 
        'item_name': d.dlItemName || '', 
        'item_id': d.dlItemId || '', 
        'item_discount_value': parseFloat(d.dlDiscountVal) || 0, 
        'item_brand': d.dlItemBrand || '', 
        'item_category': d.dlItemCategory || '', 
        'item_category2': d.dlItemCategory2 || '', 
        'item_category3': '', 
        'item_category4': '', 
        'item_category5': '', 
        'index': parseInt(d.dlIndex) || 0, 
        'item_variant': d.dlItemVariant || '', 
        'price': parseFloat(d.dlPrice) || 0, 
        'quantity': 1, 
        'item_discount_percentage': parseFloat(d.dlDiscountPct) || 0, 
        'item_stock': d.dlStock || 'In stock'
      }] 
    } 
  }); 
  sessionStorage.setItem("item_list_id", d.dlListId);
  sessionStorage.setItem("item_list_name", d.dlListName);
  console.log(window.dataLayer)
})